import React, { useEffect, useState } from "react";
import { Navbar } from "../../components/navbar/Navbar";
import { Booking } from "../../components/booking/Booking";
import { Footer } from "../../components/footer/Footer";
import { Calendar } from "../../components/calendar/Calendar";
import { OverView } from "../../components/overView/OverView";
import { ClientInfo } from "../../components/clientInfo/ClientInfo";
import { Link } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import emailJs from "emailjs-com";
import dayjs from "dayjs";
import axios from "axios";
import "./reservation.css";
import {EMPLOYEE_ENUM, getEmployee, getServicePrice} from "../../models/employees";
import { validate } from "react-email-validator";

export const Reservation = () => {
  const [selectedEmployee, setSelectedEmployee] = useState(
      getEmployee(EMPLOYEE_ENUM.Sam),
    );
  
  const [timer, setTimer] = useState(null); // State to keep the timer reference
  const [selectedService, setSelectedService] = useState(false);
  const [step, setStep] = useState(1);
  const [selectedAdditionalServices, setSelectedAdditionalServices] = useState(
    [],
  );
  const [servicesTotalPrice, setServicesTotalPrice] = useState(0);
  const [additionalServicesTimeTotal, setAdditionalServicesTimeTotal] =
    useState(0);
  const [clientData, setClientData] = useState({
    fullName: "",
    email: "",
    phone: "",
  });
  const [selectedDateRecord, setSelectedDateRecord] = useState(dayjs());
  const [selectedTimeRecord, setSelectedTimeRecord] = useState("");
  const [serviceTimeTotal, setServiceTimeTotal] = useState(15);

  useEffect(() => {
    // Clear timer when component unmounts as a cleanup
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    }, () => {clearTimeout(timer)}
  }, [timer]);

  useEffect(() => {
    if (step < 2 && timer) {
      clearTimeout(timer);
      setTimer(null);
    }}, 
    () => {clearTimeout(timer)}, 
    [step, timer]);

  const resetReservation = () => {
    setStep(1);
    setAdditionalServicesTimeTotal(0);
    setSelectedAdditionalServices([]);
    setServicesTotalPrice(0);
    setServiceTimeTotal(15);
    setSelectedTimeRecord("");
    setClientData({
      fullName: "",
      email: "",
      phone: "",
    });
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
  };

  const handleReservationButton = () => {
    setStep(2); // Move to step 2

    const newTimer = setTimeout(() => {
      alert("Čas pro vytvoření rezervace vypršel, začněte prosím znovu.");
      resetReservation();
    }, 300000);

    setTimer(newTimer);
  };

  useEffect(() => {
    setStep(1);
    setAdditionalServicesTimeTotal(0);
    setSelectedAdditionalServices([]);
    setServicesTotalPrice(0);
    setServiceTimeTotal(15);
    setSelectedTimeRecord("");
    setClientData({
      fullName: "",
      email: "",
      phone: "",
    });
  }, []);

  const [bookedDates, setBookedDates] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let fetchReservationsUri = process.env.REACT_APP_API_URL_FETCH;
        if (selectedEmployee) {
          fetchReservationsUri += `?employeeId=${selectedEmployee.id}`;
        }
        const response = await axios.get(fetchReservationsUri);
        const fetchedReservations = response.data.map((item) => ({
          id: item.id,
          date: dayjs(item.datum).format("DD.MM.YYYY"),
          startTime: dayjs(item.zacatek_cas, "HH:mm:ss").format("HH:mm"),
          finishTime: dayjs(item.konec_cas, "HH:mm:ss").format("HH:mm"),
        }));
        setBookedDates(fetchedReservations);
      } catch (err) {
        console.error("Fetching reservations failed: ", err);
      }
    };
    fetchData();
  }, [selectedEmployee, step]);

  useEffect(() => {
    selectedService.nazev
      ? setServiceTimeTotal(
          selectedService.delkaTrvani + additionalServicesTimeTotal,
        )
      : setServiceTimeTotal(additionalServicesTimeTotal);
  }, [selectedService, additionalServicesTimeTotal]);

  const isDateAvailable = (selectedDate, selectedTime, duration) => {
    const selectedStartTime = dayjs(
      selectedDate.format("YYYY-MM-DD") + " " + selectedTime,
      "YYYY-MM-DD HH:mm",
    );
    const selectedEndTime = selectedStartTime.add(duration, "minute");

    return !bookedDates.some((booking) => {
      const bookingStart = dayjs(
        booking.date + " " + booking.startTime,
        "DD.MM.YYYY HH:mm",
      );
      const bookingEnd = dayjs(
        booking.date + " " + booking.finishTime,
        "DD.MM.YYYY HH:mm",
      );

      return (
        selectedStartTime.isBefore(bookingEnd) &&
        selectedEndTime.isAfter(bookingStart)
      );
    });
  };

  const sendEmail = async () => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    if (
      !isDateAvailable(selectedDateRecord, selectedTimeRecord, serviceTimeTotal)
    ) {
      alert("Vámi zvolený termín byl během tvorby Vaší rezervace již obsazen.");
      resetReservation();
      return;
    }

    let additionalServicesString = "";
    if (selectedAdditionalServices && selectedAdditionalServices.length > 0) {
      additionalServicesString = selectedAdditionalServices
        .map((service) => service.nazev)
        .join(", ");
    }

    const postData = {
      zamestnanecId: selectedEmployee.id,
      datum: selectedDateRecord.format("YYYY-MM-DD"),
      zacatek_cas: dayjs(selectedTimeRecord, "HH:mm").format("HH:mm:ss.SSS"),
      konec_cas: dayjs(selectedTimeRecord, "HH:mm")
        .add(serviceTimeTotal, "minute")
        .format("HH:mm:ss.SSS"),
      klient_jmeno: clientData.fullName,
      klient_sluzba: selectedService.nazev || "",
      klient_sluzby_dodatecne: additionalServicesString || "",
      klient_telefon: clientData.phone,
      klient_email: clientData.email,
      klient_cena: (getServicePrice(selectedEmployee.id, selectedService) || 0) + servicesTotalPrice,
    };

    const postReservationData = async (postData) => {
      try {
        console.log(postData);
        const response = await axios.post(
          process.env.REACT_APP_API_URL_SUBMIT,
          postData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        console.log("Successfully posted data", response.data);

        if (response.data.success) {
          return { success: true };
        } else {
          return { success: false, message: response.data.message };
        }
      } catch (err) {
        console.error("Posting reservation failed:", err);
        return { success: false, message: "Chyba při komunikaci se serverem." };
      }
    };

    const successResult = await postReservationData(postData);
    if (!successResult.success) {
      alert(
        successResult.message ||
          "Rezervace se nezdařila – vybraný termín je pravděpodobně již obsazen.",
      );
      resetReservation();
      return;
    }

    // Pokud dojdeme sem, rezervace byla opravdu vytvořena --> odeslat email!

    const templateParams = {
      employeeName: selectedEmployee.name,
      clientName: clientData.fullName,
      clientPhone: clientData.phone,
      clientEmail: clientData.email,
      service: selectedService.nazev,
      date: selectedDateRecord.format("DD.MM.YYYY"),
      time: selectedTimeRecord,
      totalPrice: getServicePrice(selectedEmployee.id, selectedService) + servicesTotalPrice,
      duration: serviceTimeTotal,
      additionalServices: additionalServicesString,
    };

    emailJs
      .send(
        "service_em1i8xk",
        "template_uiettdu",
        templateParams,
        "nOyGaG-s7iiBDCwhS",
      )
      .then(
        (response) => {
          console.log("Email successfully sent!", response);
          alert(
            "Rezervace proběhla úspěšně, zkontrolujte si svůj email s termínem rezervace.",
          );
        },
        (err) => {
          console.error("Failed to send email. Error: ", err);
          alert("Nepodařilo se odeslat potvrzení rezervace emailem.");
        },
      );
  };

  return (
    <div className="reservation">
      <div className="pageWrapper">
        <Navbar />
        
        <div className="bodyContent">
          {step > 1 && (
            <ArrowBackIosNewIcon
              style={{ height: "5rem", width: "5rem" }}
              className="arrowBackIcon desktop-only"
              onClick={() => {
                setStep(step - 1);
                setAdditionalServicesTimeTotal(0);
              }}
              data-aos="fade-right"
              data-aos-duration="1200"
            />
          )}
          {step === 1 && (
            <div className="reservationSection">
              <div
                className="reservationFrame mobileFullWidth"
                data-aos="fade-down"
                data-aos-duration="1200"
              >
                <div style={{marginBottom: "15px"}}>
                <Booking
                  selectedEmployee={selectedEmployee}
                  setSelectedEmployee={setSelectedEmployee}
                  setSelectedService={setSelectedService}
                  selectedService={selectedService}
                  setServicesTotalPrice={setServicesTotalPrice}
                  selectedAdditionalServices={selectedAdditionalServices}
                  setSelectedAdditionalServices={setSelectedAdditionalServices}
                  setAdditionalServicesTimeTotal={
                    setAdditionalServicesTimeTotal
                  }
                />
                </div>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  className="reserveBtn"
                  onClick={handleReservationButton}
                  disabled={
                    !(selectedService || selectedAdditionalServices.length > 0)
                  }
                >
                  Vybrat termín
                </button>
                </div>
              </div>
              
            </div>
          )}
          {step === 2 && (
            <div className="reservationSection">
              <div
                className="reservationFrame"
                data-aos="fade-down"
                data-aos-duration="1200"
              >
                <Calendar
                  selectedEmployee={selectedEmployee}
                  setSelectedDateRecord={setSelectedDateRecord}
                  setSelectedTimeRecord={setSelectedTimeRecord}
                  serviceTimeTotal={serviceTimeTotal}
                  additionalServicesTimeTotal={additionalServicesTimeTotal}
                  bookedDates={bookedDates}
                  setStep={setStep}
                  selectedService={selectedService}
                  selectedAdditionalServices={selectedAdditionalServices}
                  servicesTotalPrice={servicesTotalPrice}
                />
              </div>
            </div>
          )}
          {step === 3 && (
            <div className="reservationSection">
              <div
                className="reservationFrame"
                data-aos="fade-down"
                data-aos-duration="1200"
              >
                <ClientInfo setClientData={setClientData} />
                <OverView
                  selectedEmployee={selectedEmployee}
                  servicesTotalPrice={servicesTotalPrice}
                  serviceTimeTotal={serviceTimeTotal}
                  selectedAdditionalServices={selectedAdditionalServices}
                  selectedService={selectedService}
                  selectedTimeRecord={selectedTimeRecord}
                  selectedDateRecord={selectedDateRecord}
                />
                <span className="cancelReservation">
                  Rezervaci prosím zrušte nejpozději 2 hodiny před sjednaným
                  termínem telefonicky nebo prostřednictvím SMS na číslo 777 606
                  447.
                  <br />
                  <b>
                    V případě neomluvené absence nebo zrušení rezervace méně než
                    2 hodiny předem bude při příští návštěvě účtován poplatek ve
                    výši 50% z ceny služby.
                  </b>
                </span>

                <p
                  style={{
                    fontSize: "14px",
                    color: "black",
                    fonstStyle: "italic",
                    padding: "0px 20px",
                  }}
                >
                  Kliknutím na tlačítko „Rezervovat“ souhlasíte s tím, že Barber
                  Shop CJ's Barbershop bude zpracovávat vaše osobní údaje
                  (jméno, telefonní číslo a e-mailová adresa) za účelem
                  realizace rezervace služby a dalších souvisejících
                  komunikačních účelů. Tyto údaje budou uchovávány v souladu s
                  našimi interními pravidly pro ochranu osobních údajů a nebudou
                  poskytovány třetím stranám bez vašeho výslovného souhlasu.
                </p>
                  {(clientData.email === "" || validate(clientData.email)) ||
                      <caption style={{ color: "red", fontSize: "12px", fontWeight: 500, padding: '5px' }}>Nelze odeslat - Nesprávný formát emailu</caption>}
                <Link className="link" to="/">
                  <button
                    className="reserveBtn"
                    text="Rezervovat termín"
                    setStep={setStep}
                    onClick={sendEmail}
                    step={step}
                    disabled={
                      !(
                        clientData.fullName &&
                        validate(clientData.email) &&
                        clientData.phone
                      )
                    }
                  >
                    Rezervovat termín
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>
        <footer>
          <Footer />
        </footer>
      </div>
    </div>
  );
};
